import React, { useState } from "react";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import { Link } from "react-router-dom";
import Binding from "../../../binding";

export default function ManualChangedItem(props) {
  let data = props || {};

  let binding = new Binding({
    id: data.object,
    entitycode: data.entitycode,
    classcode: data.classcode,
    typecode: data.typecode,
    label: data.label,
  });
  let dt = data.validfromdate ? new Date(data.validfromdate) : {};

  return (
    <>
      <div>
        <div className={`row p-5 border-top`}>
          <div className="col-lg-12 d-flex align-items-center justify-content-between">
            <div>
              <Link
                className="text-dark text-hover-muted"
                title={`Открыть ${binding.label}`}
                to={binding.url}
              >
                {binding.label}
              </Link>
              <div className="mt-2 small text-muted">
                <span className="mr-2">{data.version}</span>
                <span className="mr-2">{dt.toLocaleString()}</span>
              </div>
            </div>
            <div>
              <EssenceStateLabel
                stateCode={props.statetypecode}
                stateLabel={props.statelabel}
                essence="manual"
                id={props.id}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
